module.exports = __webpack_public_path__ + "img/city.24284cf8.png";